import React from 'react';
import PropTypes from 'prop-types';
import { FacilityGridCard } from 'components/search/FacilityGridCard';

import './facilityGrid.scss';

export function FacilityGrid({
	facilities,
	withPhone,
	withUnitsAndPrice,
	withButtonLink,
	handleFacilityCardVisible
}) {
	return (
		<div className="facility-grid">
			{facilities.map((facility) => (
				<FacilityGridCard
					key={facility.id}
					facility={facility}
					withPhone={withPhone}
					withUnitsAndPrice={withUnitsAndPrice}
					withButtonLink={withButtonLink}
					onVisible={handleFacilityCardVisible}
				/>
			))}
		</div>
	);
}
FacilityGrid.propTypes = {
	facilities: PropTypes.arrayOf(
		PropTypes.object
	),
	withPhone: PropTypes.bool,
	withUnitsAndPrice: PropTypes.bool,
	withButtonLink: PropTypes.bool,
	handleFacilityCardVisible: PropTypes.func
};

FacilityGrid.defaultProps = {
	withButtonLink: true
};

export default FacilityGrid;
